import { useState, useEffect } from 'react'
import { DesempenoIcon, EntrenamientoIcon, MotivacionesIcon } from '../../Icons/CollaboratorsIcons'
import { getEmployeeMediasByEmployerId, putEmployeeMedia } from '../../API/Services/RemuneracionVariable/EmployeeMedia'
import { btnTranslate, performancePotentialTranslate, performanceTranslate, wheelCollaboratorTranslate } from '../../i18n/translatedMessages'
import Loading from '../../Components/Loading/Loading'
import CircularBar from './Components/CircularBar/CircularBar'
import EmptyInformation from './Components/EmptyInformation/EmptyInformation'

import './desempeno.sass'
import { useParams } from 'react-router-dom'
import HeaderCarouselMandala from './Components/HeaderCarouselMandala/HeaderCarouselMandala'
import { AiOutlineEdit } from 'react-icons/ai'
import { Pill } from '../../Components/Employee/Pill/Pill'
import { StarAvaliation } from '../../Components/Employee/StarAvaliation/StarAvaliation'

const Desempeno = () => {
	const chart = true
	const { id } = useParams()
	const [data, setData] = useState([])
	const [media, setMedia] = useState(0)
	const [mediaId, setMediaId] = useState(null)
	const [loading, setLoading] = useState(true)
	const [editChange, setEditChange] = useState(true)
	const [obs, setObs] = useState('')
	const [isOpenPerformance, setIsOpenPerformance] = useState(false)
	const [isOpenPotential, setIsOpenPotential] = useState(false)
	const [is9boxOpen, setIs9boxOpen] = useState(false)

	useEffect(() => {
		const fetch = async () => {
			const [response] = await getEmployeeMediasByEmployerId(id)

			if (response) {
				setMedia(response.media)
				setData(response)
				setObs(response.observation)
				setMediaId(response.id)
			}
			setLoading(false)
		}
		fetch()
	}, [])

	const handleChange = e => {
		setObs(e)
	}

	const handleSend = async () => {
		setLoading(true)
		const sendAux = {
			answers: data,
			observation: obs,
		}
		await putEmployeeMedia(sendAux, mediaId)
		setLoading(false)
	}

	const dataPotential = data.potential?.boxValue
	const dataPerformance = data.performance?.boxValue

	const [coordinate, setCoordinate] = useState({
		cdPerformance: null,
		cdPotential: null,
	})

	useEffect(() => {
		let cdPerformance
		let cdPotential

		if (dataPerformance >= 0 && dataPerformance <= 3) {
			cdPerformance = 0
		} else if (dataPerformance > 3 && dataPerformance <= 4) {
			cdPerformance = 1
		} else if (dataPerformance > 4 && dataPerformance <= 5) {
			cdPerformance = 2
		}

		if (dataPotential >= 0 && dataPotential <= 3) {
			cdPotential = 0
		} else if (dataPotential > 3 && dataPotential <= 4) {
			cdPotential = 1
		} else if (dataPotential > 4 && dataPotential <= 5) {
			cdPotential = 2
		}

		setCoordinate({
			cdPerformance,
			cdPotential,
		})
	}, [dataPotential, dataPerformance])

	return (
		<>
			<div className='content-desempeno tw-px-20'>
				{loading && <Loading />}
				<div>
					<HeaderCarouselMandala
						actualTitle={wheelCollaboratorTranslate.performanceAnalysis}
						prevTitle={wheelCollaboratorTranslate.motivacions}
						routePrev={`/app/analytic/motivaciones/${id}`}
						nextTitle={wheelCollaboratorTranslate.training}
						routeNext={`/app/analytic/entrenamiento/${id}`}
						iconActual={<DesempenoIcon />}
						iconPrev={<MotivacionesIcon />}
						iconNext={<EntrenamientoIcon />}
					/>
				</div>
				{data ? (
					<>
						<div className='tw-space-x-5 tw-flex tw-w-full'>
							<div className='tw-w-full border tw-shadow-md tw-bg-gray-50 tw-rounded-md tw-flex tw-flex-col tw-justify-center'>
								<div
									className={`tw-w-full tw-text-left tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center  tw-bg-gray-50 tw-text-black tw-transition-colors tw-duration-100`}
								>
									<span className='tw-font-bold'>Evaluación de Desempenho</span>
									<div className='tw-flex tw-space-x-5 tw-items-center'>
										<div className='tw-flex tw-items-center tw-space-x-2'>
											<div className='tw-text-sm'>Resultado Final: </div>
											<StarAvaliation value={data.performance?.boxValue} eventColorText={isOpenPerformance} />
										</div>
									</div>
								</div>
							</div>

							<div className='tw-w-full border tw-shadow-md tw-bg-gray-50 tw-rounded-md tw-flex tw-flex-col  tw-justify-center'>
								<div
									className={`tw-w-full tw-text-left tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center tw-bg-gray-100 tw-text-black tw-transition-colors tw-duration-100`}
								>
									<span className='tw-font-bold'>Evaluación de Potencial</span>
									<div className='tw-flex tw-space-x-5 tw-items-center'>
										<div className='tw-flex tw-items-center tw-space-x-2'>
											<div className='tw-text-sm'>Resultado Final: </div>
											<StarAvaliation value={data.potential?.boxValue} eventColorText={isOpenPotential} />
										</div>
									</div>
								</div>
								{/* <div
									className={`tw-overflow-hidden tw-transition-all tw-duration-300 ${
										isOpenPotential ? 'tw-max-h-screen tw-px-4 tw-py-3' : 'tw-max-h-0'
									}`}
								>
									<div className='tw-flex tw-justify-between tw-font-bold tw-mb-5'>
										<div className='tw-w-1/2 tw-font-bold'>Potencial</div>
										<div className='tw-w-1/12 tw-flex tw-justify-between tw-font-bold'>Peso</div>
										<div className='tw-w-2/12 tw-flex tw-justify-between tw-font-bold'>Logrado</div>
									</div>

									{data.potential?.answers?.map((item, index) => (
										<div key={index} className='tw-flex tw-justify-between tw-mb-5 tw-border-b tw-pb-3'>
											<div className='tw-w-1/2'>{item.name}</div>
											<div className='tw-w-1/12'>{item.weight}</div>
											<div className='tw-w-2/12 tw-flex tw-space-x-4'>
												<div>{item.value} %</div>
												<Pill text={'Fortaleza'} color={`tw-bg-[${'#C7FFF1'}]`} eventColorText={isOpenPotential} />
											</div>
										</div>
									))}
								</div> */}
							</div>
						</div>

						<div className='tw-w-full border tw-shadow-md tw-bg-gray-50 tw-rounded-md tw-flex tw-flex-col tw-justify-center tw-mt-5 tw-cursor-pointer'>
							<div
								className={`tw-w-full tw-text-left tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center  tw-bg-gray-50 tw-text-black tw-transition-colors tw-duration-100`}
								onClick={() => setIs9boxOpen(prev => !prev)}
							>
								<span className='tw-font-bold'>Perfil 9Box</span>
								<div className='tw-flex tw-space-x-5 tw-items-center'>
									<div className='tw-flex tw-items-center tw-space-x-2'></div>
								</div>
							</div>

							<div
								className={`
      tw-flex tw-items-center tw-justify-center tw-bg-white
      tw-overflow-hidden tw-transition-all tw-duration-300
      ${is9boxOpen ? 'tw-max-h-screen tw-px-4 tw-py-3' : 'tw-max-h-0'}
    `}
							>
								<div className='tw-p-8 tw-overflow-auto tw-relativ tw-text-purple-500'>
									<table className='tw-table-fixed'>
										<tbody>
											<tr>
												<td rowSpan={6} className={`${chart ? '' : 'tw-hidden'}`}>
													<div className='[writing-mode:vertical-rl] flex flex-col tw-rotate-180 w-fit'>
														<div className='tw-w-auto-fill tw-text-center'>
															<p className='tw-text-lg tw-font-bold'>{performancePotentialTranslate.potentialTitle}</p>
														</div>
													</div>
												</td>
											</tr>
											<tr className='tw-flex'>
												<td
													className={`[writing-mode:vertical-rl] tw-rotate-180 tw-text-center tw-font-medium tw-text-lg ${chart ? '' : 'tw-hidden'}`}
												>
													4.1 - 5
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#FEF3C6] border-s-[#793510]  tw-cursor-pointer  ${
															coordinate.cdPerformance === 0 && coordinate.cdPotential === 2 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile7}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc1}</p>
													</div>
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#C7FFF1] border-s-[#0D554A] tw-cursor-pointer  ${
															coordinate.cdPerformance === 1 && coordinate.cdPotential === 2 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile9}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc2}</p>
													</div>
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#60fab2] border-s-[#0D554A] tw-cursor-pointer  ${
															coordinate.cdPerformance === 2 && coordinate.cdPotential === 2 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile8}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc3}</p>
													</div>
												</td>
											</tr>
											<tr className='tw-flex'>
												<td
													className={`[writing-mode:vertical-rl] tw-rotate-180 tw-text-center tw-font-medium tw-text-lg ${chart ? '' : 'tw-hidden'}`}
												>
													3.1 - 4
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#FEF3C6] border-s-[#793510] tw-cursor-pointer  ${
															coordinate.cdPerformance === 0 && coordinate.cdPotential === 1 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile4}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc4}</p>
													</div>
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#DFF3FE] border-s-[#084E72] tw-cursor-pointer  ${
															coordinate.cdPerformance === 1 && coordinate.cdPotential === 1 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile5}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc5}</p>
													</div>
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#C7FFF1] border-s-[#0D554A] tw-cursor-pointer  ${
															coordinate.cdPerformance === 2 && coordinate.cdPotential === 1 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile6}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc6}</p>
													</div>
												</td>
											</tr>
											<tr className='tw-flex'>
												<td
													className={`[writing-mode:vertical-rl] tw-rotate-180 tw-text-center tw-font-medium tw-text-lg ${chart ? '' : 'tw-hidden'}`}
												>
													0 - 3
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#FEE4E5] border-s-[#891336] tw-cursor-pointer  ${
															coordinate.cdPerformance === 0 && coordinate.cdPotential === 0 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile1}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc7}</p>
													</div>
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#DFF3FE] border-s-[#084E72] tw-cursor-pointer  ${
															coordinate.cdPerformance === 1 && coordinate.cdPotential === 0 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile2}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc8}</p>
													</div>
												</td>
												<td className='tw-p-2'>
													<div
														className={`tw-h-full tw-max-w-sm tw-p-6 border tw-rounded-lg tw-shadow tw-bg-[#DFF3FE] border-s-[#084E72] tw-cursor-pointer  ${
															coordinate.cdPerformance === 2 && coordinate.cdPotential === 0 ? '' : 'tw-opacity-[.2]'
														}`}
													>
														<h5 className='tw-mb-2 tw-text-2xl tw-font-bold'>{performancePotentialTranslate.profile3}</h5>
														<p>{performancePotentialTranslate.nineBoxDesc9}</p>
													</div>
												</td>
											</tr>
											<tr className={`text-center tw-flex ${chart ? '' : 'tw-hidden'}`}>
												<td></td>
												<td></td>
												<td className='tw-m-auto'>0 - 3</td>
												<td className='tw-m-auto'>3.1 - 4</td>
												<td className='tw-m-auto'>4.1 - 5</td>
											</tr>
											<tr>
												<td colSpan={4} className={`text-center ${chart ? '' : 'tw-hidden'}`}>
													<p className='tw-text-lg tw-font-bold'>{performancePotentialTranslate.performanceTitle}</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</>
				) : (
					<EmptyInformation />
				)}
			</div>
			{data && (
				<div className='container'>
					<div className='row'>
						<h5>Observación:</h5>
						<div className='col'>
							<textarea className='form-control' value={obs} onChange={e => handleChange(e.target.value)} rows={4} disabled={editChange} />
						</div>
						<div className='col-auto'>
							<div className='pb-2'>
								<button className='btn rounded-pill ms-auto btn-salvar' onClick={() => setEditChange(!editChange)}>
									<AiOutlineEdit size={28} />
								</button>
							</div>
							{!editChange && (
								<div className='pt-2'>
									<button className='btn rounded-pill ms-auto btn-salvar' onClick={handleSend}>
										{btnTranslate.saveButton}
									</button>
								</div>
							)}
						</div>
					</div>
				</div>
			)}
		</>
	)
}
export default Desempeno
